import { OffersCashbackComponent } from './offers-cashback.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersCashback: OffersCashbackComponent });
